import React from 'react';

type AutosaveStatus = 'idle' | 'autosaving' | 'saved' | 'Error';

interface AutosaveIndicatorProps {
  status: AutosaveStatus;
}

const AutosaveIndicator: React.FC<AutosaveIndicatorProps> = ({ status }) => {
  if (status === 'idle') {
    return null;
  }

  return (
    <div>
      {status === 'autosaving' && (
        <span className="text-primary900 gap-1 opacity-[0.5]">
          Autosaving...
        </span>
      )}
      {status === 'saved' && (
        <span className="text-primary900 opacity-[0.5]">
         Autosaved
        </span>
      )}
      {status === 'Error' && (
        <span className="textBody text-red-600">
          Autosave Failed
        </span>
      )}
    </div>
  );
};

export default AutosaveIndicator;
